// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/intelligence/v1/intelligence.proto (package mono.intelligence.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp, Value } from "@bufbuild/protobuf";
import { ExtractionCacheInfo } from "../../common/v1/types_pb";
/**
 * @generated from enum mono.intelligence.v1.WorkflowKind
 */ export var WorkflowKind = /*#__PURE__*/ function(WorkflowKind) {
    /**
   * @generated from enum value: WORKFLOW_KIND_UNSPECIFIED = 0;
   */ WorkflowKind[WorkflowKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: WORKFLOW_KIND_COMPANY = 1;
   */ WorkflowKind[WorkflowKind["COMPANY"] = 1] = "COMPANY";
    /**
   * @generated from enum value: WORKFLOW_KIND_CPARS = 2;
   */ WorkflowKind[WorkflowKind["CPARS"] = 2] = "CPARS";
    /**
   * @generated from enum value: WORKFLOW_KIND_QASP = 3;
   */ WorkflowKind[WorkflowKind["QASP"] = 3] = "QASP";
    /**
   * @generated from enum value: WORKFLOW_KIND_TOUCHPOINT = 4;
   */ WorkflowKind[WorkflowKind["TOUCHPOINT"] = 4] = "TOUCHPOINT";
    /**
   * @generated from enum value: WORKFLOW_KIND_DEVIATION = 5;
   */ WorkflowKind[WorkflowKind["DEVIATION"] = 5] = "DEVIATION";
    /**
   * @generated from enum value: WORKFLOW_KIND_PROOF_OF_DELIVERY = 6;
   */ WorkflowKind[WorkflowKind["PROOF_OF_DELIVERY"] = 6] = "PROOF_OF_DELIVERY";
    /**
   * A pricing sheet ingest. Unlike the kinds above it produces no field
   * proposals to reconcile into a draft — its output is a change set of type
   * 'PricingSheet' whose blocks a human accepts. It is a WorkflowKind because it
   * wants the same run record: tenant-scoped, nullable program (a pricing sheet
   * has none), and the state machine below, whose steps happen to be exactly
   * this pipeline's — convert, extract, reconcile against the registry, ready.
   *
   * @generated from enum value: WORKFLOW_KIND_PRICING_SHEET = 7;
   */ WorkflowKind[WorkflowKind["PRICING_SHEET"] = 7] = "PRICING_SHEET";
    /**
   * Award extraction/comparison, orchestrated and authorized by zou.
   *
   * @generated from enum value: WORKFLOW_KIND_AWARD_IMPORT = 8;
   */ WorkflowKind[WorkflowKind["AWARD_IMPORT"] = 8] = "AWARD_IMPORT";
    return WorkflowKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(WorkflowKind)
proto3.util.setEnumType(WorkflowKind, "mono.intelligence.v1.WorkflowKind", [
    {
        no: 0,
        name: "WORKFLOW_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "WORKFLOW_KIND_COMPANY"
    },
    {
        no: 2,
        name: "WORKFLOW_KIND_CPARS"
    },
    {
        no: 3,
        name: "WORKFLOW_KIND_QASP"
    },
    {
        no: 4,
        name: "WORKFLOW_KIND_TOUCHPOINT"
    },
    {
        no: 5,
        name: "WORKFLOW_KIND_DEVIATION"
    },
    {
        no: 6,
        name: "WORKFLOW_KIND_PROOF_OF_DELIVERY"
    },
    {
        no: 7,
        name: "WORKFLOW_KIND_PRICING_SHEET"
    },
    {
        no: 8,
        name: "WORKFLOW_KIND_AWARD_IMPORT"
    }
]);
/**
 * @generated from enum mono.intelligence.v1.IntelligenceRunState
 */ export var IntelligenceRunState = /*#__PURE__*/ function(IntelligenceRunState) {
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_UNSPECIFIED = 0;
   */ IntelligenceRunState[IntelligenceRunState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_QUEUED = 1;
   */ IntelligenceRunState[IntelligenceRunState["QUEUED"] = 1] = "QUEUED";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_UPLOADING = 2;
   */ IntelligenceRunState[IntelligenceRunState["UPLOADING"] = 2] = "UPLOADING";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_CONVERTING = 3;
   */ IntelligenceRunState[IntelligenceRunState["CONVERTING"] = 3] = "CONVERTING";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_OCR = 4;
   */ IntelligenceRunState[IntelligenceRunState["OCR"] = 4] = "OCR";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_CLASSIFYING = 5;
   */ IntelligenceRunState[IntelligenceRunState["CLASSIFYING"] = 5] = "CLASSIFYING";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_EXTRACTING = 6;
   */ IntelligenceRunState[IntelligenceRunState["EXTRACTING"] = 6] = "EXTRACTING";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_RECONCILING = 7;
   */ IntelligenceRunState[IntelligenceRunState["RECONCILING"] = 7] = "RECONCILING";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_READY_FOR_REVIEW = 8;
   */ IntelligenceRunState[IntelligenceRunState["READY_FOR_REVIEW"] = 8] = "READY_FOR_REVIEW";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_PARTIALLY_READY = 9;
   */ IntelligenceRunState[IntelligenceRunState["PARTIALLY_READY"] = 9] = "PARTIALLY_READY";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_FAILED = 10;
   */ IntelligenceRunState[IntelligenceRunState["FAILED"] = 10] = "FAILED";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_APPLIED_TO_DRAFT = 11;
   */ IntelligenceRunState[IntelligenceRunState["APPLIED_TO_DRAFT"] = 11] = "APPLIED_TO_DRAFT";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_CANCELLED = 12;
   */ IntelligenceRunState[IntelligenceRunState["CANCELLED"] = 12] = "CANCELLED";
    /**
   * @generated from enum value: INTELLIGENCE_RUN_STATE_SUPERSEDED = 13;
   */ IntelligenceRunState[IntelligenceRunState["SUPERSEDED"] = 13] = "SUPERSEDED";
    return IntelligenceRunState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(IntelligenceRunState)
proto3.util.setEnumType(IntelligenceRunState, "mono.intelligence.v1.IntelligenceRunState", [
    {
        no: 0,
        name: "INTELLIGENCE_RUN_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "INTELLIGENCE_RUN_STATE_QUEUED"
    },
    {
        no: 2,
        name: "INTELLIGENCE_RUN_STATE_UPLOADING"
    },
    {
        no: 3,
        name: "INTELLIGENCE_RUN_STATE_CONVERTING"
    },
    {
        no: 4,
        name: "INTELLIGENCE_RUN_STATE_OCR"
    },
    {
        no: 5,
        name: "INTELLIGENCE_RUN_STATE_CLASSIFYING"
    },
    {
        no: 6,
        name: "INTELLIGENCE_RUN_STATE_EXTRACTING"
    },
    {
        no: 7,
        name: "INTELLIGENCE_RUN_STATE_RECONCILING"
    },
    {
        no: 8,
        name: "INTELLIGENCE_RUN_STATE_READY_FOR_REVIEW"
    },
    {
        no: 9,
        name: "INTELLIGENCE_RUN_STATE_PARTIALLY_READY"
    },
    {
        no: 10,
        name: "INTELLIGENCE_RUN_STATE_FAILED"
    },
    {
        no: 11,
        name: "INTELLIGENCE_RUN_STATE_APPLIED_TO_DRAFT"
    },
    {
        no: 12,
        name: "INTELLIGENCE_RUN_STATE_CANCELLED"
    },
    {
        no: 13,
        name: "INTELLIGENCE_RUN_STATE_SUPERSEDED"
    }
]);
/**
 * IntelligenceRunFailureReason classifies why a FAILED run failed, so the
 * review UI can decide whether to offer Retry without regex-matching
 * error_message's raw Go error text. UNSPECIFIED is the correct value for
 * any run that is not FAILED - it does not mean "failed for an unknown
 * reason".
 *
 * @generated from enum mono.intelligence.v1.IntelligenceRunFailureReason
 */ export var IntelligenceRunFailureReason = /*#__PURE__*/ function(IntelligenceRunFailureReason) {
    /**
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_UNSPECIFIED = 0;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * The evidence itself is the problem (unsupported format, unreadable
   * document, missing required content) - retrying without different
   * evidence will fail the same way.
   *
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_UNSUPPORTED_EVIDENCE = 1;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["UNSUPPORTED_EVIDENCE"] = 1] = "UNSUPPORTED_EVIDENCE";
    /**
   * The extraction provider returned a response that could not be parsed
   * into the expected shape - often transient, retry may succeed.
   *
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_PROVIDER_INCOMPLETE_RESPONSE = 2;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["PROVIDER_INCOMPLETE_RESPONSE"] = 2] = "PROVIDER_INCOMPLETE_RESPONSE";
    /**
   * The extraction provider could not be reached or errored at the
   * transport/service level - transient, retry is likely to help.
   *
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_PROVIDER_UNAVAILABLE = 3;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["PROVIDER_UNAVAILABLE"] = 3] = "PROVIDER_UNAVAILABLE";
    /**
   * The provider responded successfully but produced no usable results -
   * retrying with the same evidence will likely fail the same way.
   *
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_NO_RESULTS = 4;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["NO_RESULTS"] = 4] = "NO_RESULTS";
    /**
   * An unexpected internal error in baltigo's own orchestration, not
   * attributable to the evidence or the provider.
   *
   * @generated from enum value: INTELLIGENCE_RUN_FAILURE_REASON_INTERNAL = 5;
   */ IntelligenceRunFailureReason[IntelligenceRunFailureReason["INTERNAL"] = 5] = "INTERNAL";
    return IntelligenceRunFailureReason;
}({});
// Retrieve enum metadata with: proto3.getEnumType(IntelligenceRunFailureReason)
proto3.util.setEnumType(IntelligenceRunFailureReason, "mono.intelligence.v1.IntelligenceRunFailureReason", [
    {
        no: 0,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_UNSPECIFIED"
    },
    {
        no: 1,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_UNSUPPORTED_EVIDENCE"
    },
    {
        no: 2,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_PROVIDER_INCOMPLETE_RESPONSE"
    },
    {
        no: 3,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_PROVIDER_UNAVAILABLE"
    },
    {
        no: 4,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_NO_RESULTS"
    },
    {
        no: 5,
        name: "INTELLIGENCE_RUN_FAILURE_REASON_INTERNAL"
    }
]);
/**
 * @generated from enum mono.intelligence.v1.ProposalReviewState
 */ export var ProposalReviewState = /*#__PURE__*/ function(ProposalReviewState) {
    /**
   * @generated from enum value: PROPOSAL_REVIEW_STATE_UNSPECIFIED = 0;
   */ ProposalReviewState[ProposalReviewState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: PROPOSAL_REVIEW_STATE_PENDING = 1;
   */ ProposalReviewState[ProposalReviewState["PENDING"] = 1] = "PENDING";
    /**
   * @generated from enum value: PROPOSAL_REVIEW_STATE_ACCEPTED = 2;
   */ ProposalReviewState[ProposalReviewState["ACCEPTED"] = 2] = "ACCEPTED";
    /**
   * @generated from enum value: PROPOSAL_REVIEW_STATE_REJECTED = 3;
   */ ProposalReviewState[ProposalReviewState["REJECTED"] = 3] = "REJECTED";
    /**
   * @generated from enum value: PROPOSAL_REVIEW_STATE_USER_EDITED = 4;
   */ ProposalReviewState[ProposalReviewState["USER_EDITED"] = 4] = "USER_EDITED";
    return ProposalReviewState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ProposalReviewState)
proto3.util.setEnumType(ProposalReviewState, "mono.intelligence.v1.ProposalReviewState", [
    {
        no: 0,
        name: "PROPOSAL_REVIEW_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "PROPOSAL_REVIEW_STATE_PENDING"
    },
    {
        no: 2,
        name: "PROPOSAL_REVIEW_STATE_ACCEPTED"
    },
    {
        no: 3,
        name: "PROPOSAL_REVIEW_STATE_REJECTED"
    },
    {
        no: 4,
        name: "PROPOSAL_REVIEW_STATE_USER_EDITED"
    }
]);
/**
 * @generated from enum mono.intelligence.v1.ProposalConflictState
 */ export var ProposalConflictState = /*#__PURE__*/ function(ProposalConflictState) {
    /**
   * @generated from enum value: PROPOSAL_CONFLICT_STATE_UNSPECIFIED = 0;
   */ ProposalConflictState[ProposalConflictState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: PROPOSAL_CONFLICT_STATE_NONE = 1;
   */ ProposalConflictState[ProposalConflictState["NONE"] = 1] = "NONE";
    /**
   * @generated from enum value: PROPOSAL_CONFLICT_STATE_RESOLVED_BY_DOCUMENT_PRIORITY = 2;
   */ ProposalConflictState[ProposalConflictState["RESOLVED_BY_DOCUMENT_PRIORITY"] = 2] = "RESOLVED_BY_DOCUMENT_PRIORITY";
    /**
   * @generated from enum value: PROPOSAL_CONFLICT_STATE_NEEDS_USER_REVIEW = 3;
   */ ProposalConflictState[ProposalConflictState["NEEDS_USER_REVIEW"] = 3] = "NEEDS_USER_REVIEW";
    return ProposalConflictState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ProposalConflictState)
proto3.util.setEnumType(ProposalConflictState, "mono.intelligence.v1.ProposalConflictState", [
    {
        no: 0,
        name: "PROPOSAL_CONFLICT_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "PROPOSAL_CONFLICT_STATE_NONE"
    },
    {
        no: 2,
        name: "PROPOSAL_CONFLICT_STATE_RESOLVED_BY_DOCUMENT_PRIORITY"
    },
    {
        no: 3,
        name: "PROPOSAL_CONFLICT_STATE_NEEDS_USER_REVIEW"
    }
]);
/**
 * @generated from enum mono.intelligence.v1.SourceLocationKind
 */ export var SourceLocationKind = /*#__PURE__*/ function(SourceLocationKind) {
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_UNSPECIFIED = 0;
   */ SourceLocationKind[SourceLocationKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_PAGE = 1;
   */ SourceLocationKind[SourceLocationKind["PAGE"] = 1] = "PAGE";
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_SLIDE = 2;
   */ SourceLocationKind[SourceLocationKind["SLIDE"] = 2] = "SLIDE";
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_SHEET = 3;
   */ SourceLocationKind[SourceLocationKind["SHEET"] = 3] = "SHEET";
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_TEXT = 4;
   */ SourceLocationKind[SourceLocationKind["TEXT"] = 4] = "TEXT";
    /**
   * @generated from enum value: SOURCE_LOCATION_KIND_EMAIL_HEADER = 5;
   */ SourceLocationKind[SourceLocationKind["EMAIL_HEADER"] = 5] = "EMAIL_HEADER";
    return SourceLocationKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SourceLocationKind)
proto3.util.setEnumType(SourceLocationKind, "mono.intelligence.v1.SourceLocationKind", [
    {
        no: 0,
        name: "SOURCE_LOCATION_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SOURCE_LOCATION_KIND_PAGE"
    },
    {
        no: 2,
        name: "SOURCE_LOCATION_KIND_SLIDE"
    },
    {
        no: 3,
        name: "SOURCE_LOCATION_KIND_SHEET"
    },
    {
        no: 4,
        name: "SOURCE_LOCATION_KIND_TEXT"
    },
    {
        no: 5,
        name: "SOURCE_LOCATION_KIND_EMAIL_HEADER"
    }
]);
/**
 * @generated from enum mono.intelligence.v1.RatingApplicability
 */ export var RatingApplicability = /*#__PURE__*/ function(RatingApplicability) {
    /**
   * @generated from enum value: RATING_APPLICABILITY_UNSPECIFIED = 0;
   */ RatingApplicability[RatingApplicability["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: RATING_APPLICABILITY_NUMERIC = 1;
   */ RatingApplicability[RatingApplicability["NUMERIC"] = 1] = "NUMERIC";
    /**
   * @generated from enum value: RATING_APPLICABILITY_NOT_APPLICABLE = 2;
   */ RatingApplicability[RatingApplicability["NOT_APPLICABLE"] = 2] = "NOT_APPLICABLE";
    /**
   * @generated from enum value: RATING_APPLICABILITY_MISSING = 3;
   */ RatingApplicability[RatingApplicability["MISSING"] = 3] = "MISSING";
    /**
   * @generated from enum value: RATING_APPLICABILITY_UNRESOLVED = 4;
   */ RatingApplicability[RatingApplicability["UNRESOLVED"] = 4] = "UNRESOLVED";
    return RatingApplicability;
}({});
// Retrieve enum metadata with: proto3.getEnumType(RatingApplicability)
proto3.util.setEnumType(RatingApplicability, "mono.intelligence.v1.RatingApplicability", [
    {
        no: 0,
        name: "RATING_APPLICABILITY_UNSPECIFIED"
    },
    {
        no: 1,
        name: "RATING_APPLICABILITY_NUMERIC"
    },
    {
        no: 2,
        name: "RATING_APPLICABILITY_NOT_APPLICABLE"
    },
    {
        no: 3,
        name: "RATING_APPLICABILITY_MISSING"
    },
    {
        no: 4,
        name: "RATING_APPLICABILITY_UNRESOLVED"
    }
]);
/**
 * DestinationEntityKind is the system-of-record entity a reviewed proposal
 * will populate. This prevents cross-entity workflows (especially Company)
 * from relying on an informal string path to select a Ryugu adapter.
 *
 * @generated from enum mono.intelligence.v1.DestinationEntityKind
 */ export var DestinationEntityKind = /*#__PURE__*/ function(DestinationEntityKind) {
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_UNSPECIFIED = 0;
   */ DestinationEntityKind[DestinationEntityKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_COMPANY_PROFILE = 1;
   */ DestinationEntityKind[DestinationEntityKind["COMPANY_PROFILE"] = 1] = "COMPANY_PROFILE";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_PROGRAM_COMPANY_ASSIGNMENT = 2;
   */ DestinationEntityKind[DestinationEntityKind["PROGRAM_COMPANY_ASSIGNMENT"] = 2] = "PROGRAM_COMPANY_ASSIGNMENT";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_COMPANY_LCAT_ALLOCATION = 3;
   */ DestinationEntityKind[DestinationEntityKind["COMPANY_LCAT_ALLOCATION"] = 3] = "COMPANY_LCAT_ALLOCATION";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_CONTACT = 4;
   */ DestinationEntityKind[DestinationEntityKind["CONTACT"] = 4] = "CONTACT";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_STAFFING_REQUIREMENT = 5;
   */ DestinationEntityKind[DestinationEntityKind["STAFFING_REQUIREMENT"] = 5] = "STAFFING_REQUIREMENT";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_CPARS_SCORE = 6;
   */ DestinationEntityKind[DestinationEntityKind["CPARS_SCORE"] = 6] = "CPARS_SCORE";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_QASP_SCORE = 7;
   */ DestinationEntityKind[DestinationEntityKind["QASP_SCORE"] = 7] = "QASP_SCORE";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_TOUCHPOINT = 8;
   */ DestinationEntityKind[DestinationEntityKind["TOUCHPOINT"] = 8] = "TOUCHPOINT";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_DEVIATION = 9;
   */ DestinationEntityKind[DestinationEntityKind["DEVIATION"] = 9] = "DEVIATION";
    /**
   * @generated from enum value: DESTINATION_ENTITY_KIND_DELIVERABLE_EVIDENCE = 10;
   */ DestinationEntityKind[DestinationEntityKind["DELIVERABLE_EVIDENCE"] = 10] = "DELIVERABLE_EVIDENCE";
    return DestinationEntityKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DestinationEntityKind)
proto3.util.setEnumType(DestinationEntityKind, "mono.intelligence.v1.DestinationEntityKind", [
    {
        no: 0,
        name: "DESTINATION_ENTITY_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DESTINATION_ENTITY_KIND_COMPANY_PROFILE"
    },
    {
        no: 2,
        name: "DESTINATION_ENTITY_KIND_PROGRAM_COMPANY_ASSIGNMENT"
    },
    {
        no: 3,
        name: "DESTINATION_ENTITY_KIND_COMPANY_LCAT_ALLOCATION"
    },
    {
        no: 4,
        name: "DESTINATION_ENTITY_KIND_CONTACT"
    },
    {
        no: 5,
        name: "DESTINATION_ENTITY_KIND_STAFFING_REQUIREMENT"
    },
    {
        no: 6,
        name: "DESTINATION_ENTITY_KIND_CPARS_SCORE"
    },
    {
        no: 7,
        name: "DESTINATION_ENTITY_KIND_QASP_SCORE"
    },
    {
        no: 8,
        name: "DESTINATION_ENTITY_KIND_TOUCHPOINT"
    },
    {
        no: 9,
        name: "DESTINATION_ENTITY_KIND_DEVIATION"
    },
    {
        no: 10,
        name: "DESTINATION_ENTITY_KIND_DELIVERABLE_EVIDENCE"
    }
]);
/**
 * DestinationFieldName is the canonical cross-service vocabulary for writable
 * proposal fields. Names deliberately match the snake_case Ryugu/domain fields.
 * Entity/field compatibility is declared by WorkflowContract.destination_fields.
 *
 * @generated from enum mono.intelligence.v1.DestinationFieldName
 */ export var DestinationFieldName = /*#__PURE__*/ function(DestinationFieldName) {
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_UNSPECIFIED = 0;
   */ DestinationFieldName[DestinationFieldName["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * Company Profile
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_COMPANY_NAME = 1;
   */ DestinationFieldName[DestinationFieldName["COMPANY_NAME"] = 1] = "COMPANY_NAME";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CAGE_CODE = 2;
   */ DestinationFieldName[DestinationFieldName["CAGE_CODE"] = 2] = "CAGE_CODE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_UEI = 3;
   */ DestinationFieldName[DestinationFieldName["UEI"] = 3] = "UEI";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_DUNS_NUMBER = 4;
   */ DestinationFieldName[DestinationFieldName["DUNS_NUMBER"] = 4] = "DUNS_NUMBER";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SOCIOECONOMIC_STATUS = 5;
   */ DestinationFieldName[DestinationFieldName["SOCIOECONOMIC_STATUS"] = 5] = "SOCIOECONOMIC_STATUS";
    /**
   * Program Company Assignment
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_PARTNER_TYPE = 10;
   */ DestinationFieldName[DestinationFieldName["PARTNER_TYPE"] = 10] = "PARTNER_TYPE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_FTE_COUNT = 11;
   */ DestinationFieldName[DestinationFieldName["FTE_COUNT"] = 11] = "FTE_COUNT";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_VACANCIES = 12;
   */ DestinationFieldName[DestinationFieldName["VACANCIES"] = 12] = "VACANCIES";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_ACTIVE = 13;
   */ DestinationFieldName[DestinationFieldName["ACTIVE"] = 13] = "ACTIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_TERMINATION_DATE = 14;
   */ DestinationFieldName[DestinationFieldName["TERMINATION_DATE"] = 14] = "TERMINATION_DATE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_WORKSHARE_PERCENTAGE = 15;
   */ DestinationFieldName[DestinationFieldName["WORKSHARE_PERCENTAGE"] = 15] = "WORKSHARE_PERCENTAGE";
    /**
   * Company LCAT Allocation and Staffing Requirement
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_LCAT = 20;
   */ DestinationFieldName[DestinationFieldName["LCAT"] = 20] = "LCAT";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LCAT_FTE = 21;
   */ DestinationFieldName[DestinationFieldName["LCAT_FTE"] = 21] = "LCAT_FTE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LCAT_VACANCIES = 22;
   */ DestinationFieldName[DestinationFieldName["LCAT_VACANCIES"] = 22] = "LCAT_VACANCIES";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LOCATION = 23;
   */ DestinationFieldName[DestinationFieldName["LOCATION"] = 23] = "LOCATION";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CONTACT_EMAILS = 24;
   */ DestinationFieldName[DestinationFieldName["CONTACT_EMAILS"] = 24] = "CONTACT_EMAILS";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_REQUIRED_FTE = 25;
   */ DestinationFieldName[DestinationFieldName["REQUIRED_FTE"] = 25] = "REQUIRED_FTE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_FILLED_FTE = 26;
   */ DestinationFieldName[DestinationFieldName["FILLED_FTE"] = 26] = "FILLED_FTE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_STAFFING_STATUS = 27;
   */ DestinationFieldName[DestinationFieldName["STAFFING_STATUS"] = 27] = "STAFFING_STATUS";
    /**
   * Contact
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_FIRST_NAME = 30;
   */ DestinationFieldName[DestinationFieldName["FIRST_NAME"] = 30] = "FIRST_NAME";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LAST_NAME = 31;
   */ DestinationFieldName[DestinationFieldName["LAST_NAME"] = 31] = "LAST_NAME";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_TITLE = 32;
   */ DestinationFieldName[DestinationFieldName["TITLE"] = 32] = "TITLE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_EMAIL = 33;
   */ DestinationFieldName[DestinationFieldName["EMAIL"] = 33] = "EMAIL";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_PHONE = 34;
   */ DestinationFieldName[DestinationFieldName["PHONE"] = 34] = "PHONE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_ORGANIZATION = 35;
   */ DestinationFieldName[DestinationFieldName["ORGANIZATION"] = 35] = "ORGANIZATION";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CONTACT_ROLE = 36;
   */ DestinationFieldName[DestinationFieldName["CONTACT_ROLE"] = 36] = "CONTACT_ROLE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CONTACT_LCATS = 37;
   */ DestinationFieldName[DestinationFieldName["CONTACT_LCATS"] = 37] = "CONTACT_LCATS";
    /**
   * Shared score fields
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_PERIOD_START = 40;
   */ DestinationFieldName[DestinationFieldName["PERIOD_START"] = 40] = "PERIOD_START";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_PERIOD_END = 41;
   */ DestinationFieldName[DestinationFieldName["PERIOD_END"] = 41] = "PERIOD_END";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_OVERALL_SCORE = 42;
   */ DestinationFieldName[DestinationFieldName["OVERALL_SCORE"] = 42] = "OVERALL_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_OVERALL_COMMENT = 43;
   */ DestinationFieldName[DestinationFieldName["OVERALL_COMMENT"] = 43] = "OVERALL_COMMENT";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_GET_WELL_PLAN = 44;
   */ DestinationFieldName[DestinationFieldName["GET_WELL_PLAN"] = 44] = "GET_WELL_PLAN";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_ATTACHMENT_ID = 45;
   */ DestinationFieldName[DestinationFieldName["ATTACHMENT_ID"] = 45] = "ATTACHMENT_ID";
    /**
   * CPARS
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_ENTRY_NUMBER = 50;
   */ DestinationFieldName[DestinationFieldName["ENTRY_NUMBER"] = 50] = "ENTRY_NUMBER";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_QUALITY_SCORE = 51;
   */ DestinationFieldName[DestinationFieldName["QUALITY_SCORE"] = 51] = "QUALITY_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SCHEDULE_SCORE = 52;
   */ DestinationFieldName[DestinationFieldName["SCHEDULE_SCORE"] = 52] = "SCHEDULE_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_COST_CONTROL_SCORE = 53;
   */ DestinationFieldName[DestinationFieldName["COST_CONTROL_SCORE"] = 53] = "COST_CONTROL_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_MANAGEMENT_SCORE = 54;
   */ DestinationFieldName[DestinationFieldName["MANAGEMENT_SCORE"] = 54] = "MANAGEMENT_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SMALL_BUSINESS_SCORE = 55;
   */ DestinationFieldName[DestinationFieldName["SMALL_BUSINESS_SCORE"] = 55] = "SMALL_BUSINESS_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_REGULATORY_COMPLIANCE_SCORE = 56;
   */ DestinationFieldName[DestinationFieldName["REGULATORY_COMPLIANCE_SCORE"] = 56] = "REGULATORY_COMPLIANCE_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_QUALITY_NARRATIVE = 57;
   */ DestinationFieldName[DestinationFieldName["QUALITY_NARRATIVE"] = 57] = "QUALITY_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SCHEDULE_NARRATIVE = 58;
   */ DestinationFieldName[DestinationFieldName["SCHEDULE_NARRATIVE"] = 58] = "SCHEDULE_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_COST_CONTROL_NARRATIVE = 59;
   */ DestinationFieldName[DestinationFieldName["COST_CONTROL_NARRATIVE"] = 59] = "COST_CONTROL_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_MANAGEMENT_NARRATIVE = 60;
   */ DestinationFieldName[DestinationFieldName["MANAGEMENT_NARRATIVE"] = 60] = "MANAGEMENT_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SMALL_BUSINESS_NARRATIVE = 61;
   */ DestinationFieldName[DestinationFieldName["SMALL_BUSINESS_NARRATIVE"] = 61] = "SMALL_BUSINESS_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_REGULATORY_COMPLIANCE_NARRATIVE = 62;
   */ DestinationFieldName[DestinationFieldName["REGULATORY_COMPLIANCE_NARRATIVE"] = 62] = "REGULATORY_COMPLIANCE_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CONCURRENCE_STATUS = 63;
   */ DestinationFieldName[DestinationFieldName["CONCURRENCE_STATUS"] = 63] = "CONCURRENCE_STATUS";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CONCURRENCE_COMMENT = 64;
   */ DestinationFieldName[DestinationFieldName["CONCURRENCE_COMMENT"] = 64] = "CONCURRENCE_COMMENT";
    /**
   * QASP
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_QUARTER = 70;
   */ DestinationFieldName[DestinationFieldName["QUARTER"] = 70] = "QUARTER";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_TECHNICAL_SCORE = 71;
   */ DestinationFieldName[DestinationFieldName["TECHNICAL_SCORE"] = 71] = "TECHNICAL_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_COST_STAFFING_SCORE = 72;
   */ DestinationFieldName[DestinationFieldName["COST_STAFFING_SCORE"] = 72] = "COST_STAFFING_SCORE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_TECHNICAL_NARRATIVE = 73;
   */ DestinationFieldName[DestinationFieldName["TECHNICAL_NARRATIVE"] = 73] = "TECHNICAL_NARRATIVE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_COST_STAFFING_NARRATIVE = 74;
   */ DestinationFieldName[DestinationFieldName["COST_STAFFING_NARRATIVE"] = 74] = "COST_STAFFING_NARRATIVE";
    /**
   * Touchpoint
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_BRIEF_DESCRIPTION = 80;
   */ DestinationFieldName[DestinationFieldName["BRIEF_DESCRIPTION"] = 80] = "BRIEF_DESCRIPTION";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_DATE_OF_BRIEFING = 81;
   */ DestinationFieldName[DestinationFieldName["DATE_OF_BRIEFING"] = 81] = "DATE_OF_BRIEFING";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_PROVIDED_BY_CONTACT_ID = 82;
   */ DestinationFieldName[DestinationFieldName["PROVIDED_BY_CONTACT_ID"] = 82] = "PROVIDED_BY_CONTACT_ID";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_PROVIDED_TO_CONTACT_ID = 83;
   */ DestinationFieldName[DestinationFieldName["PROVIDED_TO_CONTACT_ID"] = 83] = "PROVIDED_TO_CONTACT_ID";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SUMMARY_AND_ACTION_ITEMS = 84;
   */ DestinationFieldName[DestinationFieldName["SUMMARY_AND_ACTION_ITEMS"] = 84] = "SUMMARY_AND_ACTION_ITEMS";
    /**
   * Deviation
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_DEVIATION_TYPE = 90;
   */ DestinationFieldName[DestinationFieldName["DEVIATION_TYPE"] = 90] = "DEVIATION_TYPE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_CATEGORY = 91;
   */ DestinationFieldName[DestinationFieldName["CATEGORY"] = 91] = "CATEGORY";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_COMMENT = 92;
   */ DestinationFieldName[DestinationFieldName["COMMENT"] = 92] = "COMMENT";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_DEVIATION_STATE = 93;
   */ DestinationFieldName[DestinationFieldName["DEVIATION_STATE"] = 93] = "DEVIATION_STATE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_APPROVAL_SOURCE = 94;
   */ DestinationFieldName[DestinationFieldName["APPROVAL_SOURCE"] = 94] = "APPROVAL_SOURCE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_APPROVED_BY_CONTACT_ID = 95;
   */ DestinationFieldName[DestinationFieldName["APPROVED_BY_CONTACT_ID"] = 95] = "APPROVED_BY_CONTACT_ID";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_APPROVED_BY_CONTACT_NAME = 96;
   */ DestinationFieldName[DestinationFieldName["APPROVED_BY_CONTACT_NAME"] = 96] = "APPROVED_BY_CONTACT_NAME";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_ANSWERED_AT = 97;
   */ DestinationFieldName[DestinationFieldName["ANSWERED_AT"] = 97] = "ANSWERED_AT";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LINKED_CLIN_ID = 98;
   */ DestinationFieldName[DestinationFieldName["LINKED_CLIN_ID"] = 98] = "LINKED_CLIN_ID";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_LINKED_TASK_ID = 99;
   */ DestinationFieldName[DestinationFieldName["LINKED_TASK_ID"] = 99] = "LINKED_TASK_ID";
    /**
   * Deliverable Evidence
   *
   * @generated from enum value: DESTINATION_FIELD_NAME_CLAIMED_DELIVERY_TIMESTAMP = 110;
   */ DestinationFieldName[DestinationFieldName["CLAIMED_DELIVERY_TIMESTAMP"] = 110] = "CLAIMED_DELIVERY_TIMESTAMP";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_EXTRACTED_SENT_TIMESTAMP = 111;
   */ DestinationFieldName[DestinationFieldName["EXTRACTED_SENT_TIMESTAMP"] = 111] = "EXTRACTED_SENT_TIMESTAMP";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_ACCEPTED_DELIVERY_TIMESTAMP = 112;
   */ DestinationFieldName[DestinationFieldName["ACCEPTED_DELIVERY_TIMESTAMP"] = 112] = "ACCEPTED_DELIVERY_TIMESTAMP";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_DATE_VERIFICATION_STATE = 113;
   */ DestinationFieldName[DestinationFieldName["DATE_VERIFICATION_STATE"] = 113] = "DATE_VERIFICATION_STATE";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_SUBMITTED_TO_EMAILS = 114;
   */ DestinationFieldName[DestinationFieldName["SUBMITTED_TO_EMAILS"] = 114] = "SUBMITTED_TO_EMAILS";
    /**
   * @generated from enum value: DESTINATION_FIELD_NAME_PROOF_METHOD = 115;
   */ DestinationFieldName[DestinationFieldName["PROOF_METHOD"] = 115] = "PROOF_METHOD";
    return DestinationFieldName;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DestinationFieldName)
proto3.util.setEnumType(DestinationFieldName, "mono.intelligence.v1.DestinationFieldName", [
    {
        no: 0,
        name: "DESTINATION_FIELD_NAME_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DESTINATION_FIELD_NAME_COMPANY_NAME"
    },
    {
        no: 2,
        name: "DESTINATION_FIELD_NAME_CAGE_CODE"
    },
    {
        no: 3,
        name: "DESTINATION_FIELD_NAME_UEI"
    },
    {
        no: 4,
        name: "DESTINATION_FIELD_NAME_DUNS_NUMBER"
    },
    {
        no: 5,
        name: "DESTINATION_FIELD_NAME_SOCIOECONOMIC_STATUS"
    },
    {
        no: 10,
        name: "DESTINATION_FIELD_NAME_PARTNER_TYPE"
    },
    {
        no: 11,
        name: "DESTINATION_FIELD_NAME_FTE_COUNT"
    },
    {
        no: 12,
        name: "DESTINATION_FIELD_NAME_VACANCIES"
    },
    {
        no: 13,
        name: "DESTINATION_FIELD_NAME_ACTIVE"
    },
    {
        no: 14,
        name: "DESTINATION_FIELD_NAME_TERMINATION_DATE"
    },
    {
        no: 15,
        name: "DESTINATION_FIELD_NAME_WORKSHARE_PERCENTAGE"
    },
    {
        no: 20,
        name: "DESTINATION_FIELD_NAME_LCAT"
    },
    {
        no: 21,
        name: "DESTINATION_FIELD_NAME_LCAT_FTE"
    },
    {
        no: 22,
        name: "DESTINATION_FIELD_NAME_LCAT_VACANCIES"
    },
    {
        no: 23,
        name: "DESTINATION_FIELD_NAME_LOCATION"
    },
    {
        no: 24,
        name: "DESTINATION_FIELD_NAME_CONTACT_EMAILS"
    },
    {
        no: 25,
        name: "DESTINATION_FIELD_NAME_REQUIRED_FTE"
    },
    {
        no: 26,
        name: "DESTINATION_FIELD_NAME_FILLED_FTE"
    },
    {
        no: 27,
        name: "DESTINATION_FIELD_NAME_STAFFING_STATUS"
    },
    {
        no: 30,
        name: "DESTINATION_FIELD_NAME_FIRST_NAME"
    },
    {
        no: 31,
        name: "DESTINATION_FIELD_NAME_LAST_NAME"
    },
    {
        no: 32,
        name: "DESTINATION_FIELD_NAME_TITLE"
    },
    {
        no: 33,
        name: "DESTINATION_FIELD_NAME_EMAIL"
    },
    {
        no: 34,
        name: "DESTINATION_FIELD_NAME_PHONE"
    },
    {
        no: 35,
        name: "DESTINATION_FIELD_NAME_ORGANIZATION"
    },
    {
        no: 36,
        name: "DESTINATION_FIELD_NAME_CONTACT_ROLE"
    },
    {
        no: 37,
        name: "DESTINATION_FIELD_NAME_CONTACT_LCATS"
    },
    {
        no: 40,
        name: "DESTINATION_FIELD_NAME_PERIOD_START"
    },
    {
        no: 41,
        name: "DESTINATION_FIELD_NAME_PERIOD_END"
    },
    {
        no: 42,
        name: "DESTINATION_FIELD_NAME_OVERALL_SCORE"
    },
    {
        no: 43,
        name: "DESTINATION_FIELD_NAME_OVERALL_COMMENT"
    },
    {
        no: 44,
        name: "DESTINATION_FIELD_NAME_GET_WELL_PLAN"
    },
    {
        no: 45,
        name: "DESTINATION_FIELD_NAME_ATTACHMENT_ID"
    },
    {
        no: 50,
        name: "DESTINATION_FIELD_NAME_ENTRY_NUMBER"
    },
    {
        no: 51,
        name: "DESTINATION_FIELD_NAME_QUALITY_SCORE"
    },
    {
        no: 52,
        name: "DESTINATION_FIELD_NAME_SCHEDULE_SCORE"
    },
    {
        no: 53,
        name: "DESTINATION_FIELD_NAME_COST_CONTROL_SCORE"
    },
    {
        no: 54,
        name: "DESTINATION_FIELD_NAME_MANAGEMENT_SCORE"
    },
    {
        no: 55,
        name: "DESTINATION_FIELD_NAME_SMALL_BUSINESS_SCORE"
    },
    {
        no: 56,
        name: "DESTINATION_FIELD_NAME_REGULATORY_COMPLIANCE_SCORE"
    },
    {
        no: 57,
        name: "DESTINATION_FIELD_NAME_QUALITY_NARRATIVE"
    },
    {
        no: 58,
        name: "DESTINATION_FIELD_NAME_SCHEDULE_NARRATIVE"
    },
    {
        no: 59,
        name: "DESTINATION_FIELD_NAME_COST_CONTROL_NARRATIVE"
    },
    {
        no: 60,
        name: "DESTINATION_FIELD_NAME_MANAGEMENT_NARRATIVE"
    },
    {
        no: 61,
        name: "DESTINATION_FIELD_NAME_SMALL_BUSINESS_NARRATIVE"
    },
    {
        no: 62,
        name: "DESTINATION_FIELD_NAME_REGULATORY_COMPLIANCE_NARRATIVE"
    },
    {
        no: 63,
        name: "DESTINATION_FIELD_NAME_CONCURRENCE_STATUS"
    },
    {
        no: 64,
        name: "DESTINATION_FIELD_NAME_CONCURRENCE_COMMENT"
    },
    {
        no: 70,
        name: "DESTINATION_FIELD_NAME_QUARTER"
    },
    {
        no: 71,
        name: "DESTINATION_FIELD_NAME_TECHNICAL_SCORE"
    },
    {
        no: 72,
        name: "DESTINATION_FIELD_NAME_COST_STAFFING_SCORE"
    },
    {
        no: 73,
        name: "DESTINATION_FIELD_NAME_TECHNICAL_NARRATIVE"
    },
    {
        no: 74,
        name: "DESTINATION_FIELD_NAME_COST_STAFFING_NARRATIVE"
    },
    {
        no: 80,
        name: "DESTINATION_FIELD_NAME_BRIEF_DESCRIPTION"
    },
    {
        no: 81,
        name: "DESTINATION_FIELD_NAME_DATE_OF_BRIEFING"
    },
    {
        no: 82,
        name: "DESTINATION_FIELD_NAME_PROVIDED_BY_CONTACT_ID"
    },
    {
        no: 83,
        name: "DESTINATION_FIELD_NAME_PROVIDED_TO_CONTACT_ID"
    },
    {
        no: 84,
        name: "DESTINATION_FIELD_NAME_SUMMARY_AND_ACTION_ITEMS"
    },
    {
        no: 90,
        name: "DESTINATION_FIELD_NAME_DEVIATION_TYPE"
    },
    {
        no: 91,
        name: "DESTINATION_FIELD_NAME_CATEGORY"
    },
    {
        no: 92,
        name: "DESTINATION_FIELD_NAME_COMMENT"
    },
    {
        no: 93,
        name: "DESTINATION_FIELD_NAME_DEVIATION_STATE"
    },
    {
        no: 94,
        name: "DESTINATION_FIELD_NAME_APPROVAL_SOURCE"
    },
    {
        no: 95,
        name: "DESTINATION_FIELD_NAME_APPROVED_BY_CONTACT_ID"
    },
    {
        no: 96,
        name: "DESTINATION_FIELD_NAME_APPROVED_BY_CONTACT_NAME"
    },
    {
        no: 97,
        name: "DESTINATION_FIELD_NAME_ANSWERED_AT"
    },
    {
        no: 98,
        name: "DESTINATION_FIELD_NAME_LINKED_CLIN_ID"
    },
    {
        no: 99,
        name: "DESTINATION_FIELD_NAME_LINKED_TASK_ID"
    },
    {
        no: 110,
        name: "DESTINATION_FIELD_NAME_CLAIMED_DELIVERY_TIMESTAMP"
    },
    {
        no: 111,
        name: "DESTINATION_FIELD_NAME_EXTRACTED_SENT_TIMESTAMP"
    },
    {
        no: 112,
        name: "DESTINATION_FIELD_NAME_ACCEPTED_DELIVERY_TIMESTAMP"
    },
    {
        no: 113,
        name: "DESTINATION_FIELD_NAME_DATE_VERIFICATION_STATE"
    },
    {
        no: 114,
        name: "DESTINATION_FIELD_NAME_SUBMITTED_TO_EMAILS"
    },
    {
        no: 115,
        name: "DESTINATION_FIELD_NAME_PROOF_METHOD"
    }
]);
/**
 * @generated from message mono.intelligence.v1.IntelligenceTarget
 */ export class IntelligenceTarget extends Message {
    static fromBinary(bytes, options) {
        return new IntelligenceTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelligenceTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelligenceTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelligenceTarget, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string draft_id = 4;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelligenceTarget, "runtime", proto3);
_define_property(IntelligenceTarget, "typeName", "mono.intelligence.v1.IntelligenceTarget");
_define_property(IntelligenceTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.SourceLocation
 */ export class SourceLocation extends Message {
    static fromBinary(bytes, options) {
        return new SourceLocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceLocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceLocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceLocation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.SourceLocationKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: int32 index = 2;
   */ _define_property(this, "index", 0), /**
   * @generated from field: string sheet_name = 3;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: string block_id = 4;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string source_span = 5;
   */ _define_property(this, "sourceSpan", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceLocation, "runtime", proto3);
_define_property(SourceLocation, "typeName", "mono.intelligence.v1.SourceLocation");
_define_property(SourceLocation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(SourceLocationKind)
        },
        {
            no: 2,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ProposalSource
 */ export class ProposalSource extends Message {
    static fromBinary(bytes, options) {
        return new ProposalSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: mono.intelligence.v1.SourceLocation location = 4;
   */ _define_property(this, "location", void 0), /**
   * @generated from field: string excerpt = 5;
   */ _define_property(this, "excerpt", ""), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalSource, "runtime", proto3);
_define_property(ProposalSource, "typeName", "mono.intelligence.v1.ProposalSource");
_define_property(ProposalSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "location",
            kind: "message",
            T: SourceLocation
        },
        {
            no: 5,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * ProposalDestination identifies both the destination record and its canonical
 * field. entity_id is set for an existing record; client_reference groups
 * proposals for one not-yet-created record (for example a new Contact) and is
 * stable within the run. Phase 1 validation rejects unspecified kinds or field
 * names and destinations that the WorkflowContract does not declare.
 *
 * @generated from message mono.intelligence.v1.ProposalDestination
 */ export class ProposalDestination extends Message {
    static fromBinary(bytes, options) {
        return new ProposalDestination().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalDestination().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalDestination().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalDestination, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.DestinationEntityKind entity_kind = 1;
   */ _define_property(this, "entityKind", 0), /**
   * @generated from oneof mono.intelligence.v1.ProposalDestination.record
   */ _define_property(this, "record", {
            case: undefined
        }), /**
   * @generated from field: mono.intelligence.v1.DestinationFieldName field_name = 4;
   */ _define_property(this, "fieldName", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalDestination, "runtime", proto3);
_define_property(ProposalDestination, "typeName", "mono.intelligence.v1.ProposalDestination");
_define_property(ProposalDestination, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_kind",
            kind: "enum",
            T: proto3.getEnumType(DestinationEntityKind)
        },
        {
            no: 2,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            oneof: "record"
        },
        {
            no: 3,
            name: "client_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            oneof: "record"
        },
        {
            no: 4,
            name: "field_name",
            kind: "enum",
            T: proto3.getEnumType(DestinationFieldName)
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.DestinationField
 */ export class DestinationField extends Message {
    static fromBinary(bytes, options) {
        return new DestinationField().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DestinationField().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DestinationField().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DestinationField, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.DestinationEntityKind entity_kind = 1;
   */ _define_property(this, "entityKind", 0), /**
   * @generated from field: mono.intelligence.v1.DestinationFieldName field_name = 2;
   */ _define_property(this, "fieldName", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DestinationField, "runtime", proto3);
_define_property(DestinationField, "typeName", "mono.intelligence.v1.DestinationField");
_define_property(DestinationField, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_kind",
            kind: "enum",
            T: proto3.getEnumType(DestinationEntityKind)
        },
        {
            no: 2,
            name: "field_name",
            kind: "enum",
            T: proto3.getEnumType(DestinationFieldName)
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.FieldProposal
 */ export class FieldProposal extends Message {
    static fromBinary(bytes, options) {
        return new FieldProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FieldProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FieldProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FieldProposal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Human-readable diagnostic path. Routing uses destination, never this value.
   *
   * @generated from field: string target_field_path = 2;
   */ _define_property(this, "targetFieldPath", ""), /**
   * @generated from field: google.protobuf.Value current_value = 3;
   */ _define_property(this, "currentValue", void 0), /**
   * @generated from field: google.protobuf.Value proposed_value = 4;
   */ _define_property(this, "proposedValue", void 0), /**
   * @generated from field: repeated mono.intelligence.v1.ProposalSource sources = 5;
   */ _define_property(this, "sources", []), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: mono.intelligence.v1.ProposalConflictState conflict_state = 7;
   */ _define_property(this, "conflictState", 0), /**
   * @generated from field: mono.intelligence.v1.ProposalReviewState review_state = 8;
   */ _define_property(this, "reviewState", 0), /**
   * @generated from field: google.protobuf.Value reviewed_value = 9;
   */ _define_property(this, "reviewedValue", void 0), /**
   * @generated from field: repeated string warnings = 10;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: string reviewed_by_user_id = 11;
   */ _define_property(this, "reviewedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 12;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: mono.intelligence.v1.ProposalDestination destination = 13;
   */ _define_property(this, "destination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FieldProposal, "runtime", proto3);
_define_property(FieldProposal, "typeName", "mono.intelligence.v1.FieldProposal");
_define_property(FieldProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "current_value",
            kind: "message",
            T: Value
        },
        {
            no: 4,
            name: "proposed_value",
            kind: "message",
            T: Value
        },
        {
            no: 5,
            name: "sources",
            kind: "message",
            T: ProposalSource,
            repeated: true
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "conflict_state",
            kind: "enum",
            T: proto3.getEnumType(ProposalConflictState)
        },
        {
            no: 8,
            name: "review_state",
            kind: "enum",
            T: proto3.getEnumType(ProposalReviewState)
        },
        {
            no: 9,
            name: "reviewed_value",
            kind: "message",
            T: Value
        },
        {
            no: 10,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "reviewed_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "destination",
            kind: "message",
            T: ProposalDestination
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.IntelligenceRun
 */ export class IntelligenceRun extends Message {
    static fromBinary(bytes, options) {
        return new IntelligenceRun().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntelligenceRun().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntelligenceRun().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntelligenceRun, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.intelligence.v1.WorkflowKind workflow_kind = 2;
   */ _define_property(this, "workflowKind", 0), /**
   * @generated from field: mono.intelligence.v1.IntelligenceTarget target = 3;
   */ _define_property(this, "target", void 0), /**
   * @generated from field: repeated string source_artifact_ids = 4;
   */ _define_property(this, "sourceArtifactIds", []), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRunState state = 5;
   */ _define_property(this, "state", 0), /**
   * @generated from field: int32 progress_percent = 6;
   */ _define_property(this, "progressPercent", 0), /**
   * @generated from field: string current_step = 7;
   */ _define_property(this, "currentStep", ""), /**
   * @generated from field: string error_message = 8;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: repeated string warnings = 9;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: repeated mono.intelligence.v1.FieldProposal proposals = 10;
   */ _define_property(this, "proposals", []), /**
   * @generated from field: string schema_version = 11;
   */ _define_property(this, "schemaVersion", ""), /**
   * @generated from field: string extractor_version = 12;
   */ _define_property(this, "extractorVersion", ""), /**
   * @generated from field: string requested_by_user_id = 13;
   */ _define_property(this, "requestedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 16;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: mono.intelligence.v1.WorkflowExtraction extraction = 17;
   */ _define_property(this, "extraction", void 0), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRunFailureReason failure_reason = 18;
   */ _define_property(this, "failureReason", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntelligenceRun, "runtime", proto3);
_define_property(IntelligenceRun, "typeName", "mono.intelligence.v1.IntelligenceRun");
_define_property(IntelligenceRun, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workflow_kind",
            kind: "enum",
            T: proto3.getEnumType(WorkflowKind)
        },
        {
            no: 3,
            name: "target",
            kind: "message",
            T: IntelligenceTarget
        },
        {
            no: 4,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "state",
            kind: "enum",
            T: proto3.getEnumType(IntelligenceRunState)
        },
        {
            no: 6,
            name: "progress_percent",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "proposals",
            kind: "message",
            T: FieldProposal,
            repeated: true
        },
        {
            no: 11,
            name: "schema_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "extractor_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "requested_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "extraction",
            kind: "message",
            T: WorkflowExtraction
        },
        {
            no: 18,
            name: "failure_reason",
            kind: "enum",
            T: proto3.getEnumType(IntelligenceRunFailureReason)
        }
    ]));
/**
 * WorkflowContract makes document priority and supported-format policy
 * discoverable by both the UI and the extractor. Earlier entries have higher
 * authority. A tie that cannot be reconciled must produce NEEDS_USER_REVIEW.
 *
 * @generated from message mono.intelligence.v1.WorkflowContract
 */ export class WorkflowContract extends Message {
    static fromBinary(bytes, options) {
        return new WorkflowContract().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkflowContract().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkflowContract().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkflowContract, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.WorkflowKind workflow_kind = 1;
   */ _define_property(this, "workflowKind", 0), /**
   * @generated from field: string schema_version = 2;
   */ _define_property(this, "schemaVersion", ""), /**
   * @generated from field: repeated string supported_mime_types = 3;
   */ _define_property(this, "supportedMimeTypes", []), /**
   * @generated from field: repeated string document_type_priority = 4;
   */ _define_property(this, "documentTypePriority", []), /**
   * @generated from field: bool multiple_documents_allowed = 5;
   */ _define_property(this, "multipleDocumentsAllowed", false), /**
   * @generated from field: repeated string target_field_paths = 6;
   */ _define_property(this, "targetFieldPaths", []), /**
   * @generated from field: repeated mono.intelligence.v1.DestinationField destination_fields = 7;
   */ _define_property(this, "destinationFields", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkflowContract, "runtime", proto3);
_define_property(WorkflowContract, "typeName", "mono.intelligence.v1.WorkflowContract");
_define_property(WorkflowContract, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workflow_kind",
            kind: "enum",
            T: proto3.getEnumType(WorkflowKind)
        },
        {
            no: 2,
            name: "schema_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "supported_mime_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "document_type_priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "multiple_documents_allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "target_field_paths",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "destination_fields",
            kind: "message",
            T: DestinationField,
            repeated: true
        }
    ]));
/**
 * ExtractedRating preserves the source label while distinguishing numeric,
 * explicit N/A, missing, and unresolved values. Domain adapters may initially
 * persist only an accepted numeric/null value; the run retains this full shape.
 *
 * @generated from message mono.intelligence.v1.ExtractedRating
 */ export class ExtractedRating extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedRating().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedRating().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedRating().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedRating, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.RatingApplicability applicability = 1;
   */ _define_property(this, "applicability", 0), /**
   * @generated from field: optional double numeric_value = 2;
   */ _define_property(this, "numericValue", void 0), /**
   * @generated from field: string normalized_label = 3;
   */ _define_property(this, "normalizedLabel", ""), /**
   * @generated from field: string source_label = 4;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string narrative = 5;
   */ _define_property(this, "narrative", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedRating, "runtime", proto3);
_define_property(ExtractedRating, "typeName", "mono.intelligence.v1.ExtractedRating");
_define_property(ExtractedRating, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "applicability",
            kind: "enum",
            T: proto3.getEnumType(RatingApplicability)
        },
        {
            no: 2,
            name: "numeric_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 3,
            name: "normalized_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CompanyExtraction
 */ export class CompanyExtraction extends Message {
    static fromBinary(bytes, options) {
        return new CompanyExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_name = 1;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string partner_type = 2;
   */ _define_property(this, "partnerType", ""), /**
   * @generated from field: optional double subcontractor_fte = 3;
   */ _define_property(this, "subcontractorFte", void 0), /**
   * @generated from field: optional double prime_fte = 4;
   */ _define_property(this, "primeFte", void 0), /**
   * @generated from field: optional int32 vacancies = 5;
   */ _define_property(this, "vacancies", void 0), /**
   * @generated from field: repeated mono.intelligence.v1.CompanyLcatAllocation lcat_allocations = 6;
   */ _define_property(this, "lcatAllocations", []), /**
   * @generated from field: repeated mono.intelligence.v1.ExtractedContact contacts = 7;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: string subcontract_number = 8;
   */ _define_property(this, "subcontractNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 9;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp performance_start = 10;
   */ _define_property(this, "performanceStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp performance_end = 11;
   */ _define_property(this, "performanceEnd", void 0), /**
   * @generated from field: repeated string places_of_performance = 12;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: repeated string responsibilities = 13;
   */ _define_property(this, "responsibilities", []), /**
   * @generated from field: repeated string referenced_delivery_orders = 14;
   */ _define_property(this, "referencedDeliveryOrders", []), /**
   * @generated from field: repeated string workshare_letters = 15;
   */ _define_property(this, "workshareLetters", []), /**
   * @generated from field: repeated string payment_and_invoicing_requirements = 16;
   */ _define_property(this, "paymentAndInvoicingRequirements", []), /**
   * @generated from field: string cage_code = 17;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string uei = 18;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string duns_number = 19;
   */ _define_property(this, "dunsNumber", ""), /**
   * @generated from field: string socioeconomic_status = 20;
   */ _define_property(this, "socioeconomicStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyExtraction, "runtime", proto3);
_define_property(CompanyExtraction, "typeName", "mono.intelligence.v1.CompanyExtraction");
_define_property(CompanyExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "partner_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "subcontractor_fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 4,
            name: "prime_fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 6,
            name: "lcat_allocations",
            kind: "message",
            T: CompanyLcatAllocation,
            repeated: true
        },
        {
            no: 7,
            name: "contacts",
            kind: "message",
            T: ExtractedContact,
            repeated: true
        },
        {
            no: 8,
            name: "subcontract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "performance_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "performance_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "places_of_performance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "responsibilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "referenced_delivery_orders",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 15,
            name: "workshare_letters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "payment_and_invoicing_requirements",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 17,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "duns_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "socioeconomic_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CompanyLcatAllocation
 */ export class CompanyLcatAllocation extends Message {
    static fromBinary(bytes, options) {
        return new CompanyLcatAllocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyLcatAllocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyLcatAllocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyLcatAllocation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string lcat = 1;
   */ _define_property(this, "lcat", ""), /**
   * @generated from field: optional double fte = 2;
   */ _define_property(this, "fte", void 0), /**
   * @generated from field: optional int32 vacancies = 3;
   */ _define_property(this, "vacancies", void 0), /**
   * @generated from field: string location = 4;
   */ _define_property(this, "location", ""), /**
   * @generated from field: repeated string contact_emails = 5;
   */ _define_property(this, "contactEmails", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyLcatAllocation, "runtime", proto3);
_define_property(CompanyLcatAllocation, "typeName", "mono.intelligence.v1.CompanyLcatAllocation");
_define_property(CompanyLcatAllocation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 3,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 4,
            name: "location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ExtractedContact
 */ export class ExtractedContact extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedContact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string first_name = 1;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 2;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 5;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string contact_role = 7;
   */ _define_property(this, "contactRole", ""), /**
   * @generated from field: repeated string lcats = 8;
   */ _define_property(this, "lcats", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedContact, "runtime", proto3);
_define_property(ExtractedContact, "typeName", "mono.intelligence.v1.ExtractedContact");
_define_property(ExtractedContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "contact_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "lcats",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CPARSExtraction
 */ export class CPARSExtraction extends Message {
    static fromBinary(bytes, options) {
        return new CPARSExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CPARSExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CPARSExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CPARSExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp period_start = 1;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 2;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating overall = 3;
   */ _define_property(this, "overall", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating quality = 4;
   */ _define_property(this, "quality", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating schedule = 5;
   */ _define_property(this, "schedule", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating cost_control = 6;
   */ _define_property(this, "costControl", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating management = 7;
   */ _define_property(this, "management", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating small_business_subcontracting = 8;
   */ _define_property(this, "smallBusinessSubcontracting", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating regulatory_compliance = 9;
   */ _define_property(this, "regulatoryCompliance", void 0), /**
   * @generated from field: string overall_comment = 10;
   */ _define_property(this, "overallComment", ""), /**
   * @generated from field: string get_well_plan = 11;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: string concurrence_status = 12;
   */ _define_property(this, "concurrenceStatus", ""), /**
   * @generated from field: string concurrence_comment = 13;
   */ _define_property(this, "concurrenceComment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CPARSExtraction, "runtime", proto3);
_define_property(CPARSExtraction, "typeName", "mono.intelligence.v1.CPARSExtraction");
_define_property(CPARSExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "overall",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 4,
            name: "quality",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 5,
            name: "schedule",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 6,
            name: "cost_control",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 7,
            name: "management",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 8,
            name: "small_business_subcontracting",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 9,
            name: "regulatory_compliance",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 10,
            name: "overall_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "concurrence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "concurrence_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.QASPExtraction
 */ export class QASPExtraction extends Message {
    static fromBinary(bytes, options) {
        return new QASPExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QASPExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QASPExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QASPExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp period_start = 1;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 2;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string quarter = 3;
   */ _define_property(this, "quarter", ""), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating overall = 4;
   */ _define_property(this, "overall", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating technical = 5;
   */ _define_property(this, "technical", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating schedule = 6;
   */ _define_property(this, "schedule", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating cost_staffing = 7;
   */ _define_property(this, "costStaffing", void 0), /**
   * @generated from field: mono.intelligence.v1.ExtractedRating management = 8;
   */ _define_property(this, "management", void 0), /**
   * @generated from field: string get_well_plan = 9;
   */ _define_property(this, "getWellPlan", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QASPExtraction, "runtime", proto3);
_define_property(QASPExtraction, "typeName", "mono.intelligence.v1.QASPExtraction");
_define_property(QASPExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "quarter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "overall",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 5,
            name: "technical",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 6,
            name: "schedule",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 7,
            name: "cost_staffing",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 8,
            name: "management",
            kind: "message",
            T: ExtractedRating
        },
        {
            no: 9,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.TouchpointExtraction
 */ export class TouchpointExtraction extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string summary = 1;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.intelligence.v1.ExtractedActionItem action_items = 2;
   */ _define_property(this, "actionItems", []), /**
   * @generated from field: google.protobuf.Timestamp meeting_date = 3;
   */ _define_property(this, "meetingDate", void 0), /**
   * @generated from field: repeated mono.intelligence.v1.ExtractedContact participants = 4;
   */ _define_property(this, "participants", []), /**
   * @generated from field: repeated string unresolved_questions = 5;
   */ _define_property(this, "unresolvedQuestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointExtraction, "runtime", proto3);
_define_property(TouchpointExtraction, "typeName", "mono.intelligence.v1.TouchpointExtraction");
_define_property(TouchpointExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action_items",
            kind: "message",
            T: ExtractedActionItem,
            repeated: true
        },
        {
            no: 3,
            name: "meeting_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "participants",
            kind: "message",
            T: ExtractedContact,
            repeated: true
        },
        {
            no: 5,
            name: "unresolved_questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ExtractedActionItem
 */ export class ExtractedActionItem extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedActionItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedActionItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedActionItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedActionItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string description = 1;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string owner_name = 2;
   */ _define_property(this, "ownerName", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */ _define_property(this, "dueDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedActionItem, "runtime", proto3);
_define_property(ExtractedActionItem, "typeName", "mono.intelligence.v1.ExtractedActionItem");
_define_property(ExtractedActionItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.DeviationExtraction
 */ export class DeviationExtraction extends Message {
    static fromBinary(bytes, options) {
        return new DeviationExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeviationExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeviationExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeviationExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool written_confirmation_found = 1;
   */ _define_property(this, "writtenConfirmationFound", false), /**
   * @generated from field: string proposed_state = 2;
   */ _define_property(this, "proposedState", ""), /**
   * @generated from field: string approval_source = 3;
   */ _define_property(this, "approvalSource", ""), /**
   * @generated from field: string approver_name = 4;
   */ _define_property(this, "approverName", ""), /**
   * @generated from field: string approver_organization = 5;
   */ _define_property(this, "approverOrganization", ""), /**
   * @generated from field: google.protobuf.Timestamp answered_at = 6;
   */ _define_property(this, "answeredAt", void 0), /**
   * @generated from field: string category = 7;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string comment = 8;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string linked_clin_number = 9;
   */ _define_property(this, "linkedClinNumber", ""), /**
   * @generated from field: string linked_task_reference = 10;
   */ _define_property(this, "linkedTaskReference", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeviationExtraction, "runtime", proto3);
_define_property(DeviationExtraction, "typeName", "mono.intelligence.v1.DeviationExtraction");
_define_property(DeviationExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "written_confirmation_found",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "proposed_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "approval_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "approver_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "approver_organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "linked_clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "linked_task_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SourceTimestamp preserves how a timestamp appeared in evidence as well as
 * its normalized instant. utc_offset records an ISO-8601 offset such as -04:00;
 * timezone_name carries a named zone when the source provides one.
 *
 * @generated from message mono.intelligence.v1.SourceTimestamp
 */ export class SourceTimestamp extends Message {
    static fromBinary(bytes, options) {
        return new SourceTimestamp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceTimestamp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceTimestamp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceTimestamp, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp normalized = 1;
   */ _define_property(this, "normalized", void 0), /**
   * @generated from field: string raw_value = 2;
   */ _define_property(this, "rawValue", ""), /**
   * @generated from field: string utc_offset = 3;
   */ _define_property(this, "utcOffset", ""), /**
   * @generated from field: string timezone_name = 4;
   */ _define_property(this, "timezoneName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceTimestamp, "runtime", proto3);
_define_property(SourceTimestamp, "typeName", "mono.intelligence.v1.SourceTimestamp");
_define_property(SourceTimestamp, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "normalized",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "raw_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "timezone_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ProofOfDeliveryExtraction
 */ export class ProofOfDeliveryExtraction extends Message {
    static fromBinary(bytes, options) {
        return new ProofOfDeliveryExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProofOfDeliveryExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProofOfDeliveryExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProofOfDeliveryExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.SourceTimestamp sent_at = 1;
   */ _define_property(this, "sentAt", void 0), /**
   * @generated from field: string sender = 2;
   */ _define_property(this, "sender", ""), /**
   * @generated from field: repeated string recipients = 3;
   */ _define_property(this, "recipients", []), /**
   * @generated from field: string subject = 4;
   */ _define_property(this, "subject", ""), /**
   * @generated from field: mono.intelligence.v1.SourceTimestamp receipt_at = 5;
   */ _define_property(this, "receiptAt", void 0), /**
   * @generated from field: string proof_description = 6;
   */ _define_property(this, "proofDescription", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProofOfDeliveryExtraction, "runtime", proto3);
_define_property(ProofOfDeliveryExtraction, "typeName", "mono.intelligence.v1.ProofOfDeliveryExtraction");
_define_property(ProofOfDeliveryExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sent_at",
            kind: "message",
            T: SourceTimestamp
        },
        {
            no: 2,
            name: "sender",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "subject",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "receipt_at",
            kind: "message",
            T: SourceTimestamp
        },
        {
            no: 6,
            name: "proof_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkflowExtraction is the validated, workflow-shaped result from baltigo.
 * FieldProposal remains the review/apply contract; this typed payload prevents
 * extractor implementations from inventing incompatible JSON shapes.
 *
 * @generated from message mono.intelligence.v1.WorkflowExtraction
 */ export class WorkflowExtraction extends Message {
    static fromBinary(bytes, options) {
        return new WorkflowExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkflowExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkflowExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkflowExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.intelligence.v1.WorkflowExtraction.extraction
   */ _define_property(this, "extraction", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkflowExtraction, "runtime", proto3);
_define_property(WorkflowExtraction, "typeName", "mono.intelligence.v1.WorkflowExtraction");
_define_property(WorkflowExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company",
            kind: "message",
            T: CompanyExtraction,
            oneof: "extraction"
        },
        {
            no: 2,
            name: "cpars",
            kind: "message",
            T: CPARSExtraction,
            oneof: "extraction"
        },
        {
            no: 3,
            name: "qasp",
            kind: "message",
            T: QASPExtraction,
            oneof: "extraction"
        },
        {
            no: 4,
            name: "touchpoint",
            kind: "message",
            T: TouchpointExtraction,
            oneof: "extraction"
        },
        {
            no: 5,
            name: "deviation",
            kind: "message",
            T: DeviationExtraction,
            oneof: "extraction"
        },
        {
            no: 6,
            name: "proof_of_delivery",
            kind: "message",
            T: ProofOfDeliveryExtraction,
            oneof: "extraction"
        },
        {
            no: 7,
            name: "award_import",
            kind: "message",
            T: AwardImportExtraction,
            oneof: "extraction"
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.AwardImportExtraction
 */ export class AwardImportExtraction extends Message {
    static fromBinary(bytes, options) {
        return new AwardImportExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AwardImportExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AwardImportExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AwardImportExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: mono.common.v1.ExtractionCacheInfo cache_info = 2;
   */ _define_property(this, "cacheInfo", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AwardImportExtraction, "runtime", proto3);
_define_property(AwardImportExtraction, "typeName", "mono.intelligence.v1.AwardImportExtraction");
_define_property(AwardImportExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cache_info",
            kind: "message",
            T: ExtractionCacheInfo
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CreateIntelligenceRunRequest
 */ export class CreateIntelligenceRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateIntelligenceRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIntelligenceRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIntelligenceRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIntelligenceRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.WorkflowKind workflow_kind = 1;
   */ _define_property(this, "workflowKind", 0), /**
   * @generated from field: mono.intelligence.v1.IntelligenceTarget target = 2;
   */ _define_property(this, "target", void 0), /**
   * @generated from field: repeated string source_artifact_ids = 3;
   */ _define_property(this, "sourceArtifactIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIntelligenceRunRequest, "runtime", proto3);
_define_property(CreateIntelligenceRunRequest, "typeName", "mono.intelligence.v1.CreateIntelligenceRunRequest");
_define_property(CreateIntelligenceRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workflow_kind",
            kind: "enum",
            T: proto3.getEnumType(WorkflowKind)
        },
        {
            no: 2,
            name: "target",
            kind: "message",
            T: IntelligenceTarget
        },
        {
            no: 3,
            name: "source_artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CreateIntelligenceRunResponse
 */ export class CreateIntelligenceRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateIntelligenceRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIntelligenceRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIntelligenceRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIntelligenceRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIntelligenceRunResponse, "runtime", proto3);
_define_property(CreateIntelligenceRunResponse, "typeName", "mono.intelligence.v1.CreateIntelligenceRunResponse");
_define_property(CreateIntelligenceRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.GetIntelligenceRunRequest
 */ export class GetIntelligenceRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetIntelligenceRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetIntelligenceRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetIntelligenceRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetIntelligenceRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetIntelligenceRunRequest, "runtime", proto3);
_define_property(GetIntelligenceRunRequest, "typeName", "mono.intelligence.v1.GetIntelligenceRunRequest");
_define_property(GetIntelligenceRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.GetIntelligenceRunResponse
 */ export class GetIntelligenceRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetIntelligenceRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetIntelligenceRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetIntelligenceRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetIntelligenceRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetIntelligenceRunResponse, "runtime", proto3);
_define_property(GetIntelligenceRunResponse, "typeName", "mono.intelligence.v1.GetIntelligenceRunResponse");
_define_property(GetIntelligenceRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ListIntelligenceRunsRequest
 */ export class ListIntelligenceRunsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelligenceRunsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelligenceRunsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelligenceRunsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelligenceRunsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.WorkflowKind workflow_kind = 1;
   */ _define_property(this, "workflowKind", 0), /**
   * @generated from field: mono.intelligence.v1.IntelligenceTarget target = 2;
   */ _define_property(this, "target", void 0), /**
   * @generated from field: repeated mono.intelligence.v1.IntelligenceRunState states = 3;
   */ _define_property(this, "states", []), /**
   * @generated from field: int32 page_size = 4;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 5;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelligenceRunsRequest, "runtime", proto3);
_define_property(ListIntelligenceRunsRequest, "typeName", "mono.intelligence.v1.ListIntelligenceRunsRequest");
_define_property(ListIntelligenceRunsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workflow_kind",
            kind: "enum",
            T: proto3.getEnumType(WorkflowKind)
        },
        {
            no: 2,
            name: "target",
            kind: "message",
            T: IntelligenceTarget
        },
        {
            no: 3,
            name: "states",
            kind: "enum",
            T: proto3.getEnumType(IntelligenceRunState),
            repeated: true
        },
        {
            no: 4,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ListIntelligenceRunsResponse
 */ export class ListIntelligenceRunsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIntelligenceRunsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIntelligenceRunsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIntelligenceRunsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIntelligenceRunsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.intelligence.v1.IntelligenceRun runs = 1;
   */ _define_property(this, "runs", []), /**
   * @generated from field: string next_page_token = 2;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIntelligenceRunsResponse, "runtime", proto3);
_define_property(ListIntelligenceRunsResponse, "typeName", "mono.intelligence.v1.ListIntelligenceRunsResponse");
_define_property(ListIntelligenceRunsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "runs",
            kind: "message",
            T: IntelligenceRun,
            repeated: true
        },
        {
            no: 2,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.StartIntelligenceRunRequest
 */ export class StartIntelligenceRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartIntelligenceRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartIntelligenceRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartIntelligenceRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartIntelligenceRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartIntelligenceRunRequest, "runtime", proto3);
_define_property(StartIntelligenceRunRequest, "typeName", "mono.intelligence.v1.StartIntelligenceRunRequest");
_define_property(StartIntelligenceRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.StartIntelligenceRunResponse
 */ export class StartIntelligenceRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartIntelligenceRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartIntelligenceRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartIntelligenceRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartIntelligenceRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartIntelligenceRunResponse, "runtime", proto3);
_define_property(StartIntelligenceRunResponse, "typeName", "mono.intelligence.v1.StartIntelligenceRunResponse");
_define_property(StartIntelligenceRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.RetryIntelligenceRunRequest
 */ export class RetryIntelligenceRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetryIntelligenceRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetryIntelligenceRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetryIntelligenceRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetryIntelligenceRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetryIntelligenceRunRequest, "runtime", proto3);
_define_property(RetryIntelligenceRunRequest, "typeName", "mono.intelligence.v1.RetryIntelligenceRunRequest");
_define_property(RetryIntelligenceRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.RetryIntelligenceRunResponse
 */ export class RetryIntelligenceRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetryIntelligenceRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetryIntelligenceRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetryIntelligenceRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetryIntelligenceRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetryIntelligenceRunResponse, "runtime", proto3);
_define_property(RetryIntelligenceRunResponse, "typeName", "mono.intelligence.v1.RetryIntelligenceRunResponse");
_define_property(RetryIntelligenceRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CancelIntelligenceRunRequest
 */ export class CancelIntelligenceRunRequest extends Message {
    static fromBinary(bytes, options) {
        return new CancelIntelligenceRunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelIntelligenceRunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelIntelligenceRunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelIntelligenceRunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelIntelligenceRunRequest, "runtime", proto3);
_define_property(CancelIntelligenceRunRequest, "typeName", "mono.intelligence.v1.CancelIntelligenceRunRequest");
_define_property(CancelIntelligenceRunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.CancelIntelligenceRunResponse
 */ export class CancelIntelligenceRunResponse extends Message {
    static fromBinary(bytes, options) {
        return new CancelIntelligenceRunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelIntelligenceRunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelIntelligenceRunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelIntelligenceRunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelIntelligenceRunResponse, "runtime", proto3);
_define_property(CancelIntelligenceRunResponse, "typeName", "mono.intelligence.v1.CancelIntelligenceRunResponse");
_define_property(CancelIntelligenceRunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ReviewFieldProposalRequest
 */ export class ReviewFieldProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewFieldProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewFieldProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewFieldProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewFieldProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: string proposal_id = 2;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: mono.intelligence.v1.ProposalReviewState review_state = 3;
   */ _define_property(this, "reviewState", 0), /**
   * @generated from field: google.protobuf.Value reviewed_value = 4;
   */ _define_property(this, "reviewedValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewFieldProposalRequest, "runtime", proto3);
_define_property(ReviewFieldProposalRequest, "typeName", "mono.intelligence.v1.ReviewFieldProposalRequest");
_define_property(ReviewFieldProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "review_state",
            kind: "enum",
            T: proto3.getEnumType(ProposalReviewState)
        },
        {
            no: 4,
            name: "reviewed_value",
            kind: "message",
            T: Value
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ReviewFieldProposalResponse
 */ export class ReviewFieldProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewFieldProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewFieldProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewFieldProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewFieldProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.FieldProposal proposal = 1;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewFieldProposalResponse, "runtime", proto3);
_define_property(ReviewFieldProposalResponse, "typeName", "mono.intelligence.v1.ReviewFieldProposalResponse");
_define_property(ReviewFieldProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: FieldProposal
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.ProposalReviewDecision
 */ export class ProposalReviewDecision extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_id = 1;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: mono.intelligence.v1.ProposalReviewState review_state = 2;
   */ _define_property(this, "reviewState", 0), /**
   * @generated from field: google.protobuf.Value reviewed_value = 3;
   */ _define_property(this, "reviewedValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewDecision, "runtime", proto3);
_define_property(ProposalReviewDecision, "typeName", "mono.intelligence.v1.ProposalReviewDecision");
_define_property(ProposalReviewDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_state",
            kind: "enum",
            T: proto3.getEnumType(ProposalReviewState)
        },
        {
            no: 3,
            name: "reviewed_value",
            kind: "message",
            T: Value
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.BulkReviewFieldProposalsRequest
 */ export class BulkReviewFieldProposalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkReviewFieldProposalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkReviewFieldProposalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkReviewFieldProposalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkReviewFieldProposalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: repeated mono.intelligence.v1.ProposalReviewDecision decisions = 2;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkReviewFieldProposalsRequest, "runtime", proto3);
_define_property(BulkReviewFieldProposalsRequest, "typeName", "mono.intelligence.v1.BulkReviewFieldProposalsRequest");
_define_property(BulkReviewFieldProposalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decisions",
            kind: "message",
            T: ProposalReviewDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.BulkReviewFieldProposalsResponse
 */ export class BulkReviewFieldProposalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkReviewFieldProposalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkReviewFieldProposalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkReviewFieldProposalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkReviewFieldProposalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkReviewFieldProposalsResponse, "runtime", proto3);
_define_property(BulkReviewFieldProposalsResponse, "typeName", "mono.intelligence.v1.BulkReviewFieldProposalsResponse");
_define_property(BulkReviewFieldProposalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.MarkRunAppliedToDraftRequest
 */ export class MarkRunAppliedToDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkRunAppliedToDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkRunAppliedToDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkRunAppliedToDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkRunAppliedToDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: string draft_id = 2;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: repeated string proposal_ids = 3;
   */ _define_property(this, "proposalIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkRunAppliedToDraftRequest, "runtime", proto3);
_define_property(MarkRunAppliedToDraftRequest, "typeName", "mono.intelligence.v1.MarkRunAppliedToDraftRequest");
_define_property(MarkRunAppliedToDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.MarkRunAppliedToDraftResponse
 */ export class MarkRunAppliedToDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkRunAppliedToDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkRunAppliedToDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkRunAppliedToDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkRunAppliedToDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.IntelligenceRun run = 1;
   */ _define_property(this, "run", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkRunAppliedToDraftResponse, "runtime", proto3);
_define_property(MarkRunAppliedToDraftResponse, "typeName", "mono.intelligence.v1.MarkRunAppliedToDraftResponse");
_define_property(MarkRunAppliedToDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run",
            kind: "message",
            T: IntelligenceRun
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.GetWorkflowContractRequest
 */ export class GetWorkflowContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkflowContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkflowContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkflowContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkflowContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.WorkflowKind workflow_kind = 1;
   */ _define_property(this, "workflowKind", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkflowContractRequest, "runtime", proto3);
_define_property(GetWorkflowContractRequest, "typeName", "mono.intelligence.v1.GetWorkflowContractRequest");
_define_property(GetWorkflowContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workflow_kind",
            kind: "enum",
            T: proto3.getEnumType(WorkflowKind)
        }
    ]));
/**
 * @generated from message mono.intelligence.v1.GetWorkflowContractResponse
 */ export class GetWorkflowContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkflowContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkflowContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkflowContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkflowContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.intelligence.v1.WorkflowContract contract = 1;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkflowContractResponse, "runtime", proto3);
_define_property(GetWorkflowContractResponse, "typeName", "mono.intelligence.v1.GetWorkflowContractResponse");
_define_property(GetWorkflowContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: WorkflowContract
        }
    ]));
